import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { AuthGuard } from "src/auth/guard";
import { LoadingScreen } from "src/components/loading-screen";
import DefaultLayout from "src/layouts/default";
import { paths } from "src/routes/paths";

// ----------------------------------------------------------------------

const AccountListView = lazy(() => import("src/sections/accounts/list/view"));
const CreateAccountView = lazy(
  () => import("src/sections/accounts/create/view")
);
const AccountDetailView = lazy(
  () => import("src/sections/accounts/detail/view")
);
const ChangePasswordView = lazy(
  () => import("src/sections/my-account/change-password/view")
);

// ----------------------------------------------------------------------

export const accountManagementRoutes = [
  {
    element: (
      <AuthGuard>
        <DefaultLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DefaultLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: paths.accountManagement.root,
        element: <AccountListView />,
      },
      {
        path: paths.accountManagement.create,
        element: <CreateAccountView />,
      },
      {
        path: paths.accountManagement.detail,
        element: <AccountDetailView />,
      },
    ],
  },
];
